import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { removeAccents } from '../../../../../helpers/common'
import { Checkbox } from '../../../../html/checkbox'
import { Element } from '../../../../html/element'
import { Icon } from '../../../../html/icon'
import { InputDropdown } from '../../../../html/input/InputDropdown'
import { ScrollComponent } from '../../../../scrollComponent'
import {
  changeListSelectedProvince,
  changeTextSearchProvince,
  selectDataProvince,
  selectListSelectedProvince,
  selectTextSearchProvince,
} from '../../../store/sliceProvince'

import { SCROLL_COMPONENT_IDS } from '../../../constant'
import { LayoutContent } from '../layoutContent'

export const Province = () => {
  const dispatch = useDispatch()

  const data = useSelector(selectDataProvince)
  const listSelected = useSelector(selectListSelectedProvince)
  const textSearch = useSelector(selectTextSearchProvince)

  const [isShowDropdown, setIsShowDropdown] = useState(false)

  const listDrop = [
    ...data.filter((item) =>
      removeAccents(item.name.toLowerCase()).includes(
        removeAccents(textSearch.trim().toLowerCase()),
      ),
    ),
  ]

  const onChange = (e) => {
    dispatch(changeTextSearchProvince(e.target.value))
  }

  const clearText = () => {
    dispatch(changeTextSearchProvince(''))
  }

  const handleChoose = (item) => {
    dispatch(
      changeListSelectedProvince({
        value: item.id,
        label: item.name,
      }),
    )
  }

  const handleOpenDropdown = () => {
    setIsShowDropdown(true)
  }

  const handleHideDropdown = () => {
    setIsShowDropdown(false)
    clearText()
  }

  const renderDropdown = () => {
    if (!listDrop) {
      return (
        <div className="fstItalic">
          <Translate value="library.main.NODATA_SEARCH_COMPANY" />
        </div>
      )
    }

    return (
      <ScrollComponent autoHeight autoHeightMax={400}>
        {listDrop?.map((item) => (
          <DropdownItem
            key={item?.id}
            item={item}
            listSelected={listSelected}
            handleChoose={handleChoose}
          />
        ))}
      </ScrollComponent>
    )
  }

  return (
    <div>
      <InputDropdown
        placeHolder="library.filterSetting.PROVINCE_HOLDER"
        value={textSearch}
        onChange={onChange}
        isShowDropdown={isShowDropdown}
        setIsShowDropdown={setIsShowDropdown}
        onClickOutsideDropdown={handleHideDropdown}
        onClick={handleOpenDropdown}
        inputProps={{
          style: { fontSize: 12 },
          noControl: true,
          isShowIcon: false,
          customElement: (
            <Icon
              className="icon-caret-bottom pointerEventsNone"
              style={{
                fontSize: 8,
                left: 'unset',
                right: 4,
              }}
            />
          ),
        }}
        dropdownContainerStyle={{
          minHeight: 50,
        }}
        containerStyle={{ width: 200 }}
        scrollId={SCROLL_COMPONENT_IDS}
      >
        {renderDropdown()}
      </InputDropdown>
      <Element
        elementName="p"
        style={{
          fontStyle: 'italic',
          padding: '4px 0',
        }}
      >
        {!!listSelected?.length && (
          <Translate
            value={`library.main.${
              !listSelected?.length || listSelected?.length < 2
                ? 'ITEM_SINGLE_SELECT'
                : 'ITEM_SELECT'
            }`}
            count={listSelected?.length}
          />
        )}
      </Element>

      <LayoutContent
        data={listSelected}
        onClickDelete={(item) => {
          dispatch(changeListSelectedProvince(item))
        }}
      />
    </div>
  )
}

export const DropdownItem = ({ item, handleChoose, listSelected }) => {
  const [bgColor, setBgColor] = useState('transparent')

  const onMouseEnter = () => {
    setBgColor('#F3F3F3')
  }

  const onMouseLeave = () => {
    setBgColor('transparent')
  }

  return (
    <Element
      onClick={(e) => {
        handleChoose(item)
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{ backgroundColor: bgColor }}
      className="cursorPointer"
    >
      <Element
        style={{
          borderBottom: '1px solid #D5D5D5',
        }}
      >
        <Checkbox
          title={item.name}
          checked={listSelected.map((item) => item.value).includes(item.id)}
          onChange={() => {
            handleChoose(item)
          }}
          isCheckOnClickText
          styleIcon={{ fontSize: 15, paddingRight: 8 }}
          style={{ padding: '6px 0' }}
        />
      </Element>
    </Element>
  )
}
